import * as types from "./actionTypes";
import Cookies from "js-cookie";

export function saveLeadGeneration(emailId, website, isGoogleActive, eCommercePlatform) {
    return async function (dispatch) {
        console.log("saving Lead request...");
        console.log(emailId,website,isGoogleActive,eCommercePlatform);
           await dispatch({
                    type: types.UPDATE_LEAD_GENERATION,
                    data:{ emailId:emailId, website: website }
                });
        try {
            const url = "/save-lead-generation.json";
            let response = await fetch(url, {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'X-CSRF-Token': Cookies.get('CSRF-TOKEN')
                },
                'credentials': 'include',
                body: new URLSearchParams({
                emailId: emailId,
                website: website,
                isGoogleActive: isGoogleActive,
                eCommercePlatform: eCommercePlatform
                })
            });
//             let data = await response.json();
//             console.log("Demo request saved = ", data);
//             return data;
        } catch (e) {
            console.log("exception", e);
        }
    }
}